// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wdzT","delete":"styles_delete__1_ln2","update":"styles_update__3OLtH","add":"styles_add__vCKh3"};